import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './WelcomeModal.css'

const STORAGE_KEY = 'damanati_welcome_seen'

const slides = {
  ar: [
    {
      icon: '🎉',
      title: 'مرحباً بك في ضماناتي!',
      subtitle: 'تطبيقك الذكي لحفظ ومتابعة ضمانات منتجاتك. لن تفقد ضماناً بعد اليوم.',
    },
    {
      icon: '💡',
      title: 'نصائح سريعة',
      tips: [
        { icon: '📷', text: 'صوّر وصلك وسيتم استخراج البيانات تلقائياً' },
        { icon: '🔔', text: 'سنذكّرك قبل انتهاء أي ضمان' },
        { icon: '📄', text: 'يمكنك إرفاق ملف PDF لوثيقة الضمان' },
      ],
    },
    {
      icon: '🚀',
      title: 'أنت جاهز!',
      subtitle: 'يمكنك إضافة حتى 5 ضمانات مجاناً. ابدأ بإضافة أول ضمان الآن!',
      counter: 5,
      counterLabel: 'ضمانات مجانية',
    },
  ],
  en: [
    {
      icon: '🎉',
      title: 'Welcome to Damanati!',
      subtitle: 'Your smart app for saving and tracking product warranties. Never lose a warranty again.',
    },
    {
      icon: '💡',
      title: 'Quick Tips',
      tips: [
        { icon: '📷', text: 'Photograph your receipt and data is extracted automatically' },
        { icon: '🔔', text: "We'll remind you before any warranty expires" },
        { icon: '📄', text: 'You can attach a PDF of your warranty document' },
      ],
    },
    {
      icon: '🚀',
      title: "You're all set!",
      subtitle: 'You can add up to 5 warranties for free. Start by adding your first one now!',
      counter: 5,
      counterLabel: 'free warranties',
    },
  ],
}

const btnText = {
  ar: { next: 'التالي', start: 'أضف أول ضمان', skip: 'تخطي' },
  en: { next: 'Next', start: 'Add First Warranty', skip: 'Skip' },
}

export default function WelcomeModal({ lang = 'ar', onClose }) {
  const [step, setStep] = useState(0)
  const navigate = useNavigate()
  const s = slides[lang] || slides.ar
  const btn = btnText[lang] || btnText.ar
  const current = s[step]
  const isLast = step === s.length - 1

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') dismiss() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    onClose()
  }

  const handleNext = () => {
    if (isLast) {
      dismiss()
      navigate('/add')
    } else {
      setStep(step + 1)
    }
  }

  return (
    <div className="welcome-overlay" onClick={dismiss} dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="welcome-modal" onClick={e => e.stopPropagation()}>
        <button className="welcome-close" onClick={dismiss} aria-label="Close">&times;</button>

        <span className="welcome-icon">{current.icon}</span>
        <div className="welcome-title">{current.title}</div>

        {current.subtitle && (
          <div className="welcome-subtitle">{current.subtitle}</div>
        )}

        {current.tips && (
          <div className="welcome-tip-list">
            {current.tips.map((tip, i) => (
              <div className="welcome-tip" key={i}>
                <span className="welcome-tip-icon">{tip.icon}</span>
                <span className="welcome-tip-text">{tip.text}</span>
              </div>
            ))}
          </div>
        )}

        {current.counter && (
          <div className="welcome-counter">
            <div className="welcome-counter-num">{current.counter}</div>
            <div className="welcome-counter-label">{current.counterLabel}</div>
          </div>
        )}

        <div className="welcome-dots">
          {s.map((_, i) => (
            <div key={i} className={`welcome-dot ${i === step ? 'active' : ''}`} />
          ))}
        </div>

        <button className="welcome-btn-primary" onClick={handleNext}>
          {isLast ? btn.start : btn.next}
        </button>

        {!isLast && (
          <button className="welcome-btn-skip" onClick={dismiss}>
            {btn.skip}
          </button>
        )}
      </div>
    </div>
  )
}
